import { AppSidebar } from "@/lib/shadcn/components/sidebar";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { userSidebarItems } from "@/pages/userSidebar";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/lib/shadcn/ui/sidebar";
import ProfileDropdown from "@/lib/molecules/profileDropdown";

const TABLET_BREAKPOINT = 1024;

function useIsTabletOrSmaller() {
    const [isTabletOrSmaller, setIsTabletOrSmaller] = useState(typeof window !== "undefined" ? window.innerWidth < TABLET_BREAKPOINT : false);

    useEffect(() => {
        const handleResize = () => {
            setIsTabletOrSmaller(window.innerWidth < TABLET_BREAKPOINT);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isTabletOrSmaller;
}

export default function UserLayout() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const isTabletOrSmaller = useIsTabletOrSmaller();

    useEffect(() => {
        if (!user || !user.visibleOwners) {
            navigate("/login");
        }
    }, [navigate, user]);

    if (!user) {
        return <Navigate to="/login" />;
    }

    return (
        <SidebarProvider id={"#sidebar"} defaultOpen={!isTabletOrSmaller}>
            <AppSidebar
                sections={userSidebarItems}
                user={{
                    name: user.givenName,
                    email: user.email,
                    avatar: user.profileImageUri,
                }}
            />
            <SidebarInset>
                <header className="flex justify-between h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
                    <div className="flex items-center gap-2 px-4">
                        <SidebarTrigger className="-ml-1" />
                    </div>
                    <div className="mr-7">
                        <ProfileDropdown profileImageUrl={user?.profileImageUri} userName={user?.givenName || ""} />
                    </div>
                </header>
                <div className="flex flex-1 flex-col gap-4 p-4 pt-0">
                    <main className="p-1">
                        <Outlet />
                    </main>
                </div>
            </SidebarInset>
        </SidebarProvider>
    );
}
